export default __webpack_public_path__ + "static/media/evgeny.25e99b03.png";